/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CouponId200,
  GetApiV1CouponId401,
  GetApiV1CouponId404,
  GetApiV1CouponId500,
  GetApiV1CouponIdPathParams,
  GetApiV1CouponIdQueryResponse,
} from "../../types/couponRegistroController/GetApiV1CouponId.ts";
import { couponViewModelSchema } from "../couponViewModelSchema.ts";

export const getApiV1CouponIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CouponIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CouponId200Schema = z.lazy(
  () => couponViewModelSchema,
) as unknown as ToZod<GetApiV1CouponId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CouponId401Schema =
  z.any() as unknown as ToZod<GetApiV1CouponId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CouponId404Schema =
  z.any() as unknown as ToZod<GetApiV1CouponId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CouponId500Schema =
  z.any() as unknown as ToZod<GetApiV1CouponId500>;

export const getApiV1CouponIdQueryResponseSchema = z.lazy(
  () => getApiV1CouponId200Schema,
) as unknown as ToZod<GetApiV1CouponIdQueryResponse>;
